import TriMoji from "./TriMoji";

const BlessedPoop = TriMoji({ top: "🤲", mid: "✨", bottom: "💩" });

export default BlessedPoop;
